import Skeleton from './Skeleton.component';

export default Skeleton;
